import { EntityAction } from '../../types';
import { LessonPlanEntityMutationActionType } from './types';

const defaultState = {
  lessonPlan: []
};
const lessonPlanMutationReducer = (state = defaultState as any, action: EntityAction) => {
  switch (action.type) {
    case LessonPlanEntityMutationActionType.UPDATE_ENTITY: {
      return {
        ...state,
        lessonPlan: action.data
      };
    }

    default:
      return state;
  }
};

export default lessonPlanMutationReducer;
